import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import { withStyles } from '@material-ui/core/styles';

import { Section } from '../../ContentEdit';

import { startEditBid, startEditBidTemplate } from '../../../../store/actions/bids';
import { startEditBidEditorState } from '../../../../store/actions/bidEditor';

const styles = theme => ({
  root: {

  },
  center: {
    alignSelf: 'center',
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    flexGrow: 1,
  },
  accredation: {
    alignSelf: 'flex-end',
  },
  basic: {
    display: 'flex',
    flexDirection: 'column',
  }
});

const Credibility = ({ classes, bid, preview, startEditBid, startEditBidEditorState, startEditBidTemplate }) => {
  const {
    showCredibility = false,
    credibility = {
      showBasic: false,
      showNumbers: false,
    }
  } = bid.template;

  return(
    <div>
      <Section
        preview={preview}
        title="Credibility and Client Comfort"
        showContent={true}
        showAdd
        menuItems={[
            {
              title: "None",
              action: startEditBidTemplate,
              payload: {
                bidId: bid.id,
                type: 'credibility',
                updates: {
                  showBasic: false,
                  showLogos: false,
                  showNumbers: false,
                }
              },
              editorState: () => startEditBidEditorState("credNoneButton"),
            },
            {
              type: "divider",
            },
            {
              title: "Basic",
              action: startEditBidTemplate,
              payload: {
                bidId: bid.id,
                type: 'credibility',
                updates: {
                  showBasic: true,
                  showLogos: false,
                  showNumbers: false,
                }
              },
              editorState: () => startEditBidEditorState("credBasicButton"),
            },
            {
              title: "Details",
              action: startEditBidTemplate,
              payload: {
                bidId: bid.id,
                type: 'credibility',
                updates: {
                  showBasic: true,
                  showLogos: false,
                  showNumbers: true,
                }
              },
              editorState: () => startEditBidEditorState("credDetailsButton"),
            },

      ]}>
        <div className={classes.flexColumn}>
          {credibility.showBasic &&
            <div className={classes.basic}>
              <TextField
                disabled={preview}
                id="notes"
                label="Notes"
                className={classes.textField}
                multiline
                placeholder="Enter note"
                margin="normal"
                value={bid.notes}
                onFocus={() => startEditBidEditorState("credNotes")}
                onChange={(event) => {
                  const value = event.target.value;
                  startEditBid(bid.id, {notes: value})
                }}
              />
              <TextField
                disabled={preview}
                id="terms"
                label="Terms"
                className={classes.textField}
                multiline
                rows="6"
                placeholder="Enter terms"
                margin="normal"
                value={bid.terms}
                onFocus={() => startEditBidEditorState("credTerms")}
                onChange={(event) => {
                  const value = event.target.value;
                  startEditBid(bid.id, {terms: value})
                }}
              />
              <Typography className={classes.center}>
                Thank you for your business!
              </Typography>
            </div>
          }
          {credibility.showNumbers &&
            <div className={classes.flexRow}>
              <div />
              <div className={classes.flexColumn}>
                <TextField
                  disabled={preview}
                  id="taxNumber"
                  label="Tax Number"
                  className={classes.textField}
                  placeholder="should be prepoluated"
                  margin="normal"
                  value={bid.taxNumber}
                  onFocus={() => startEditBidEditorState("credTaxNumber")}
                  onChange={(event) => {
                    const value = event.target.value;
                    startEditBid(bid.id, {taxNumber: value})
                  }}
                />
                <TextField
                  disabled={preview}
                  id="companyNumber"
                  label="Company Number"
                  className={classes.textField}
                  placeholder="Should be prepoluated"
                  margin="normal"
                  value={bid.companyNumber}
                  onFocus={() => startEditBidEditorState("credCompanyNumber")}
                  onChange={(event) => {
                    const value = event.target.value;
                    startEditBid(bid.id, {companyNumber: value})
                  }}
                />
              </div>
            </div>
          }
        </div>
      </Section>
    </div>
  );
};

Credibility.defaultProps = {
  bid: {
    template: {}
  }
};

const mapStateToProps = (state) => ({
  bid: state.bidsState.find( bid => bid.id === state.adminState.bid.id ),
});

const mapDispatchToProps = (dispatch) => ({
  startEditBid: (bidId, bid) => dispatch(startEditBid(bidId, bid)),
  startEditBidEditorState: (key) => dispatch(startEditBidEditorState(key)),
  startEditBidTemplate: (bidId, type, payload) => dispatch(startEditBidTemplate(bidId, type, payload)),
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(Credibility);



// WEBPACK FOOTER //
// ./src/components/admin/Bids/Detail/Credibility.jsx